import CRMRetargetingSegmentsView from "./CRMRetargetingSegmentsView";

export default CRMRetargetingSegmentsView;
